import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import moment from "moment";
import { useEffect } from "react";

const Datepicker = ({
  id,
  name,
  register,
  errors,
  title,
  placeholder,
  optional,
  initialValue,
  timeFormat,
  readOnly,
  setValue,
  clearErrors,
  onDateChange,
  ...rest
}) => {
  const handleDateChange = (date) => {
    let formatted_date = moment(date).format("MM-DD-yyyy");

    if (timeFormat !== false)
      formatted_date = moment(date).format("MM-DD-yyyy hh:mm a");

    clearErrors(name);
    setValue(name, formatted_date);

    if (onDateChange) onDateChange(date);
  };

  useEffect(() => {
    if (initialValue) {
      let formatted_date = moment(initialValue).format("MM-DD-yyyy");

      if (timeFormat !== false)
        formatted_date = moment(initialValue).format("MM-DD-yyyy hh:mm a");

      clearErrors(name);
      setValue(name, formatted_date);
    }
  }, [initialValue, setValue, clearErrors, name, timeFormat]);

  let inputProps = {
    readOnly,
    placeholder,
    className: `form-control ${errors[name] && "form-invalid"}`,
  };

  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
          {optional && (
            <span className="text-xs ml-2 text-gray-300">Optional</span>
          )}
        </label>
      )}
      <Datetime
        id={id}
        name={name}
        className="form-control"
        inputProps={inputProps}
        initialValue={initialValue}
        onChange={handleDateChange}
        timeFormat={timeFormat}
        closeOnSelect
        ref={register.ref}
        {...rest}
      />
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default Datepicker;
